<template>
  <b-button v-b-modal.modal-help>
    <b-icon-question-circle aria-hidden="true"></b-icon-question-circle>
    Help
    <b-modal
        id="modal-help"
        title="Instructions"
        ok-only
        ok-title="Close">
      <p>
        The design tool allows you to customize your product by uploading,
        resizing, and positioning an image.
      </p>
      <ol>
      <li>
        To start, use the <strong>Select Image</strong> button to upload a
        new image or to select an image previously uploaded.
      </li>
      <li>
        In the center frame, reposition the selected image on the top of the
        printable area by dragging.
        Use the <strong>Zoom</strong> and <strong>Center</strong> buttons
        to center or to resize the image until it's in the right place.
      </li>
      <li>
        Select a quantity and hit <strong>Review and Add to Cart</strong>
        to add it to your order.
      </li>
    </ol>
      <p>
        That's it! Press <strong>New</strong> to start again with a blank cap.
      </p>
      <p>
        If you think you might want to order this design again in the future,
        you can save your design. Click <strong>Save</strong> to save for later.
        When you come back, use <strong>Load</strong> to bring it back.
      </p>
      <p>
        To save multiple designs with small differences, like cap color, use
        <strong>Copy</strong> to make a new version of the currently saved design.
      </p>
      <p>
        We recommend <a href="/signin">creating an account</a>
        to save your designs for the future. Without an account, designs
        are only saved on this browser, and may be lost in time.
      </p>
    </b-modal>
  </b-button>
</template>

<script>
import { BIconQuestionCircle } from 'bootstrap-vue';

export default {
  name: 'Help',
  components: {
    BIconQuestionCircle,
  },
  props: {
    // msg: String,
  },
  computed: {
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p, li {
  color: #333;
}
strong {
  color: black;
}
</style>
